import { CompanyTypes } from '../enums';

export interface CustomerBillingDataModel {
  isCompany: boolean;
  firstName: string;
  lastName: string;
  nationalIdentityDocument: string;
  nationalIdentificationDocumentType?: number;
  email: string;
  streetName: string;
  postalCode: string;
  locality: string;
  province: string;
  bankAccount: string;
}

export interface InvoicerCompanyBillingDataModel {
  id: number;
  name: string;
  companyType: CompanyTypes;
}
